import { render, staticRenderFns } from "./TypeNav.vue?vue&type=template&id=7134b06a&scoped=true&"
import script from "./TypeNav.vue?vue&type=script&lang=js&"
export * from "./TypeNav.vue?vue&type=script&lang=js&"
import style0 from "./TypeNav.vue?vue&type=style&index=0&id=7134b06a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7134b06a",
  null
  
)

export default component.exports